export enum TripEventWebViewType {
  openLink = 'openLink',
}
